'use client';

import { useState } from 'react';
import { Sparkles, X, ArrowRight } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

export function NewVersionBanner() {
  const { setLayoutVersion } = useTheme();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-gray-900 dark:bg-[#1a1a1a] text-white text-sm border-b border-gray-800 dark:border-[#2a2a2a]">
      <Sparkles size={14} className="text-gray-400 flex-shrink-0" />
      <span className="text-gray-300 text-[13px]">Nova versão disponível — visual mais limpo e minimalista.</span>
      <button
        onClick={() => setLayoutVersion('v2')}
        className="flex items-center gap-1.5 ml-auto px-3 py-1 bg-white text-gray-900 rounded text-[12px] font-medium hover:bg-gray-100 transition-colors flex-shrink-0"
      >
        Experimentar
        <ArrowRight size={12} />
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="p-0.5 text-gray-500 hover:text-gray-300 transition-colors flex-shrink-0"
        aria-label="Dispensar"
      >
        <X size={14} />
      </button>
    </div>
  );
}
